<template>
  <section class="container py-5">

    <div class="mb-5">
      <MockTable :idArray="BalancesTableData.idArray" :title="BalancesTableData.title" :nameArray="BalancesTableData.nameArray" :valueArray="BalancesTableData.valueArray" :detailArray="BalancesTableData.detailArray" @removeItem="removeBalance"></MockTable>
      <MockForm :payload="balancepayload" @payload="balancepayload = $event" :handleSubmit="createBalance"
        instuctionUrl="https://enablebanking.com/docs/api/reference/#balanceresource" />
    </div>
    <div>
      <MockTable :idArray="TransacationsTableData.idArray" :title="TransacationsTableData.title" :nameArray="TransacationsTableData.nameArray" :valueArray="TransacationsTableData.valueArray" :detailArray="TransacationsTableData.detailArray" @removeItem="removeTransaction"></MockTable>
      <MockForm :payload="transactionpayload" @payload="transactionpayload = $event"
        :handleSubmit="createTransactions"
        instuctionUrl="https://enablebanking.com/docs/api/reference/#transaction" />
    </div>
  </section>

</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import metadata from '../mixins/metadata.js'
import parseError from '../mixins/parseError.js'
import MockTable from '../components/MockTable.vue'
import MockForm from '../components/MockForm.vue'
import axios from 'axios'
import { API_V2_PREFIX } from '../config'

export default {
  name: 'MockAccountData',
  mixins: [metadata, parseError],
  data() {
    return {
      balances: null,
      balancepayload: this.getBalanceJson(),
      transactions: null,
      transactionpayload: this.getTransactionJson()
    }
  },
  async mounted() {
    const resourceId = this.$route.params.id
    await this.fetchBalances(resourceId)
    await this.fetchTransactions(resourceId)
  },
  computed: {
    ...mapGetters(['loading', 'idToken']),
    BalancesTableData() {
      let valueArray = null
      const idArray = []
      const detailArray = []
      if (this.balances != null) {
        valueArray = []
        this.balances.forEach(balance => {
          var temp = []
          temp.push(balance.payload.name)
          temp.push(balance.payload.balance_type)
          temp.push(balance.payload.balance_amount.amount)
          temp.push(balance.payload.balance_amount.currency)
          idArray.push(balance.balance_id)
          valueArray.push(temp)
          detailArray.push(balance.payload)
        })
      }
      return {
        title: 'Balances',
        nameArray: ['Balance Name', 'Balance Type', 'Amount', 'Currency'],
        valueArray: valueArray,
        idArray: idArray,
        detailArray: detailArray
      }
    },
    TransacationsTableData() {
      let valueArray = null
      const idArray = []
      const detailArray = []
      if (this.transactions != null) {
        valueArray = []
        this.transactions.forEach(transaction => {
          var temp = []
          temp.push(transaction.payload.booking_date)
          temp.push(transaction.payload.status)
          temp.push(transaction.payload.credit_debit_indicator)
          temp.push(transaction.payload.transaction_amount.amount)
          temp.push(transaction.payload.transaction_amount.currency)
          idArray.push(transaction.transaction_id)
          valueArray.push(temp)
          detailArray.push(transaction.payload)
        })
      }
      return {
        title: 'Transactions',
        nameArray: ['Booking date', 'Status', 'Credit/Debit', 'Amount', 'Currency'],
        valueArray: valueArray,
        idArray: idArray,
        detailArray: detailArray
      }
    }
  },
  components: {
    MockTable,
    MockForm
  },
  methods: {
    ...mapActions(['pushAlertMessage', 'setLoading']),
    async fetchBalances(resourceId) {
      try {
        const res = await axios({
          method: 'get',
          url: `${API_V2_PREFIX}/cp/mock-aspsp/accounts/${resourceId}/balances`,
          headers: {
            Authorization: 'Bearer ' + this.idToken.token
          }
        })
        this.balances = res.data.balances
      } catch (e) {
        this.pushAlertMessage({ message: `Something went wrong: ${e}` })
      }
    },
    async fetchTransactions(resourceId) {
      try {
        const res = await axios({
          method: 'get',
          url: `${API_V2_PREFIX}/cp/mock-aspsp/accounts/${resourceId}/transactions?page_size=10`, // default page size is 10
          headers: {
            Authorization: 'Bearer ' + this.idToken.token
          }
        })
        this.transactions = res.data.transactions
      } catch (e) {
        this.pushAlertMessage({ message: `Something went wrong: ${e}` })
      }
    },
    pickRandom(arr) {
      return arr[(Math.random() * arr.length) | 0]
    },
    getBalanceJson() {
      return JSON.stringify({
        name: 'Closing accounting balance',
        balance_amount: {
          currency: 'EUR',
          amount: ((Math.random() * (100) + 0.02).toFixed(2)).toString()
        },
        balance_type: this.pickRandom(['CLBD', 'ITAV', 'ITBD'])
      }, null, 2)
    },
    getTransactionJson() {
      const creditDebitIndicator = this.pickRandom(['CRDT', 'DBIT'])
      const entryReference = Math.random().toString(36).substring(2, 7)
      const transactionAmount = ((Math.random() * (10) + 0.02).toFixed(2)).toString()
      const yesterdayTimeStamp = new Date() - 1000 * 60 * 60 * 24 * 1
      const randomDate = new Date(yesterdayTimeStamp - Math.random() * (1000 * 60 * 60 * 24 * 3)) // random date in 3 days
      const creditorName = this.pickRandom(['Aino', 'Akseli', 'Ella', 'Onni', 'Oliver']) + ' ' + this.pickRandom(['Virtanen', 'Korhonen', 'Mäkinen', 'Nieminen', 'Hämäläinen'])
      return JSON.stringify({
        entry_reference: entryReference,
        transaction_amount: {
          currency: 'EUR',
          amount: transactionAmount
        },
        creditor: {
          name: creditorName
        },
        credit_debit_indicator: creditDebitIndicator,
        status: 'BOOK',
        booking_date: new Date(yesterdayTimeStamp).toISOString().slice(0, 10),
        value_date: randomDate.toISOString().slice(0, 10),
        remittance_information: [
          `${creditorName}-${creditDebitIndicator}-${transactionAmount}-${entryReference}`
        ]
      }, null, 2)
    },
    async removeBalance(balanceId) {
      const resourceId = this.$route.params.id
      this.setLoading(true)
      try {
        await axios({
          method: 'delete',
          url: `${API_V2_PREFIX}/cp/mock-aspsp/accounts/${resourceId}/balances/${balanceId}`,
          headers: {
            Authorization: 'Bearer ' + this.idToken.token
          }
        })
        this.pushAlertMessage({ message: 'Balance has been removed', type: 'info' })
        await this.fetchBalances(resourceId)
      } catch (e) {
        this.pushAlertMessage({ message: `Something went wrong: ${e}` })
      } finally {
        this.setLoading(false)
      }
    },
    async createBalance() {
      const resourceId = this.$route.params.id
      const body = {
        payload: JSON.parse(this.balancepayload)
      }
      try {
        await axios({
          method: 'post',
          url: `${API_V2_PREFIX}/cp/mock-aspsp/accounts/${resourceId}/balances`,
          data: body,
          headers: {
            Authorization: 'Bearer ' + this.idToken.token
          }
        })
        this.balancepayload = this.getBalanceJson()
        this.pushAlertMessage({ message: 'Balance has been added', type: 'info' })
      } catch (e) {
        this.pushAlertMessage({ message: this.parseErrorMessage(e) })
      }
      await this.fetchBalances(resourceId)
    },
    async removeTransaction(transactionId) {
      console.log(transactionId)
      const resourceId = this.$route.params.id
      this.setLoading(true)
      try {
        await axios({
          method: 'delete',
          url: `${API_V2_PREFIX}/cp/mock-aspsp/accounts/${resourceId}/transactions/${transactionId}`,
          headers: {
            Authorization: 'Bearer ' + this.idToken.token
          }
        })
        this.pushAlertMessage({ message: 'Transaction has been removed', type: 'info' })
        await this.fetchTransactions(resourceId)
      } catch (e) {
        this.pushAlertMessage({ message: `Something went wrong: ${e}` })
      } finally {
        this.setLoading(false)
      }
    },
    async createTransactions() {
      const resourceId = this.$route.params.id
      const body = {
        payload: JSON.parse(this.transactionpayload)
      }
      try {
        await axios({
          method: 'post',
          url: `${API_V2_PREFIX}/cp/mock-aspsp/accounts/${resourceId}/transactions`,
          data: body,
          headers: {
            Authorization: 'Bearer ' + this.idToken.token
          }
        })

        this.transactionpayload = this.getTransactionJson()
        this.pushAlertMessage({ message: 'Transaction has been added', type: 'info' })
      } catch (e) {
        this.pushAlertMessage({ message: this.parseErrorMessage(e) })
      }
      await this.fetchTransactions(resourceId)
    }
  }
}
</script>
